/** The fields the settlement-type rule reads off a deduction or transaction row. */
export interface SettlementTypeRow {
  kind?: string | null
  import_source?: string | null
}

/** `deduction.import_source` stamped by the direct-bill importer (`server/src/direct_bill/`). */
export const DIRECT_BILL_IMPORT_SOURCE = "admin_portal_direct_bill"

/**
 * A direct billing is a trade-spend bill the brand paid the customer for by check request. It is
 * stored as `kind = deduction` so it codes and accrues like one, but it never came off a customer's
 * remittance, and Saffron Road's accounting team needs to split the two apart in the export.
 */
export function is_direct_billing(row: SettlementTypeRow): boolean {
  return row.import_source === DIRECT_BILL_IMPORT_SOURCE
}

/**
 * What the export's "Settlement type" column (`kind`) reads: the stored kind, except that a direct
 * billing says so instead of "deduction".
 */
export function settlement_type(row: SettlementTypeRow): string {
  if (is_direct_billing(row)) return "direct billing"
  return row.kind ?? ""
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("settlement_type", () => {
    it("labels rows from the direct-bill importer as direct billing", () => {
      expect(settlement_type({ kind: "deduction", import_source: "admin_portal_direct_bill" })).toBe("direct billing")
    })

    it("leaves every other row on its stored kind", () => {
      expect(settlement_type({ kind: "deduction", import_source: "portal" })).toBe("deduction")
      expect(settlement_type({ kind: "invoice", import_source: "admin_portal_jc_remit" })).toBe("invoice")
      expect(settlement_type({ kind: "repayment" })).toBe("repayment")
      expect(settlement_type({})).toBe("")
    })
  })
}
